"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const styles_1 = require("components/ResourceRegister/styles");
const useStyle = (0, mui_1.makeStyles)()(styles_1.DeleteDialogStyles);
const DeleteDialog = ({ hasTxns, category, hasChildren }) => {
    const { classes } = useStyle();
    const categoryName = (<strong className={classes.bold}>{category.name}</strong>);
    const quickenDeleteWithTnxs = (<p>
      You are deleting {categoryName}.
      All transactions assigned to this category will be uncategorized. <br />
      Are you sure you want to delete {categoryName}{hasChildren ? ' and its subcategories' : ''}?
    </p>);
    if (hasTxns) {
        return quickenDeleteWithTnxs;
    }
    return hasChildren ? (<p>Deleting {categoryName} will delete all subcategories of {categoryName}.</p>) : (<p>Are you sure you would want to delete {categoryName}?</p>);
};
exports.default = DeleteDialog;
